import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import barReducer from './slices/bar';
import itemsReducer from './slices/item';
import usersReducer from './slices/users';
import unitsReducer from './slices/units';
import chequeReducer from './slices/cheque';
import inventoryReducer from './slices/kitchen';
import employeeReducer from './slices/employees';
import categoriesReducer from './slices/category';
import suppliersReducer from './slices/suppliers';
import barSummaryReducer from './slices/bar-summary';
import permissionsReducer from './slices/permissions';
import monthlySalesReducer from './slices/monthly-sales';
import purchaseAnalysisReducer from './slices/purchase-analysis';
import advancedPaymentsReducer from './slices/advanced-payments';
import inventoryAnalysisReducer from './slices/inventory-analysis';
import barDispatchOrdersReducer from './slices/bar-dispatch-order';
import barPurchaseOrdersReducer from './slices/bar-purchase-order';
import kitchenPurchaseOrdersReducer from './slices/kitchen-purchase-order';
import kitchenDispatchOrdersReducer from './slices/kitchen-dispatch-order';
import monthlySalesQuantitiesReducer from './slices/monthly-sales-quantities';

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  users: usersReducer,
  inventory: inventoryReducer,
  permissions: permissionsReducer,
  units: unitsReducer,
  categories: categoriesReducer,
  bar: barReducer,
  suppliers: suppliersReducer,
  employees: employeeReducer,
  kitchenPurchaseOrders: kitchenPurchaseOrdersReducer,
  kitchenDispatchOrders: kitchenDispatchOrdersReducer,
  barDispatchOrders: barDispatchOrdersReducer,
  barPurchaseOrders: barPurchaseOrdersReducer,
  items: itemsReducer,
  barSummary: barSummaryReducer,
  inventoryAnalysis: inventoryAnalysisReducer,
  purchaseAnalysis: purchaseAnalysisReducer,
  monthlySales: monthlySalesReducer,
  monthlySalesQuantities: monthlySalesQuantitiesReducer,
  cheque: chequeReducer,
  advancedPayments: advancedPaymentsReducer,
});

export { rootPersistConfig, rootReducer };
